var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path4, _path5, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _path6, _path7, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _path8, _path9, _path0, _path1, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _path10, _path11, _path12, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _circle, _path98;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 481,
    viewBox: "0 0 586 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.51 291.384H222V470H377V233.031H339.673V242.282H335.245V312.021H325.122V319.849H300.449V173.255H292.857V152.618H282.102V127H269.449V152.618H258.694V173.255H251.735V319.849H243.51V291.384Z",
    fill: "#B0C8CC",
    stroke: "#B0C8CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M538.572 311.937H526V454H613V299.605H573.272V124H538.572V311.937Z",
    fill: "#B0C8CC",
    stroke: "#B0C8CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.51 292.384H223V471H378V234.031H340.673V243.282H336.245V313.021H326.122V320.849H301.449V174.255H293.857V153.618H283.102V128H270.449V153.618H259.694V174.255H252.735V320.849H244.51V292.384Z",
    fill: "#B0C8CC",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 260.5,
    y: 185.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 216.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 260.5,
    y: 264.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 312.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 346.5,
    y: 281.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 228.5,
    y: 372.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 283.5,
    y: 449.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 257.5,
    y: 405.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 267.5,
    y: 346.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 493.5,
    y: 384.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 472.5,
    y: 341.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 499.5,
    y: 297.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 482.5,
    y: 266.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 499.5,
    y: 203.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 544.5,
    y: 138.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 179.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 363.5,
    y: 247.5,
    width: 6,
    height: 10,
    fill: "#030000",
    stroke: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 472,
    width: 586,
    height: 9,
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.5 373V382",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M586 286.415V410.647V471H527V208H544.911V232.67H559.134V256.459H573.884V286.415H586Z",
    fill: "#8D8097",
    stroke: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 301.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 320.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 338.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 376.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 414.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 357.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 574.5,
    y: 452.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 263.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 282.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 301.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 320.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 338.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 357.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 376.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 414.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 452.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 243.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 243.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 263.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 282.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 301.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 320.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 338.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 376.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 414.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 357.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 547.5,
    y: 452.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 263.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 282.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 301.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 320.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 338.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 376.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 414.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 357.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 433.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 561.5,
    y: 452.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 533.5,
    y: 217.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M377 472V198.363H389.572V142.973H396.11V115.041H403.15V106.52H409.185V51.1294L421.254 36.9268L432.821 51.1294V106.52H439.358V115.041H446.902V142.973H453.439V198.363H464V472H434.832H406.671H377Z",
    fill: "#F2E8E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406.671 198.363V472M406.671 198.363H389.572M406.671 198.363V142.973H396.11M406.671 472H377V198.363H389.572M406.671 472H434.832M389.572 198.363V142.973H396.11M396.11 142.973V115.041H403.15M434.832 472V198.363M434.832 472H464V198.363H453.439M434.832 198.363V142.973H446.902M434.832 198.363H453.439M453.439 198.363V142.973H446.902M446.902 142.973V115.041H439.358M439.358 115.041V106.52H432.821M439.358 115.041H403.15M403.15 115.041V106.52H409.185M409.185 106.52V51.1294M409.185 106.52H432.821M409.185 51.1294H432.821M409.185 51.1294L421.254 36.9268M432.821 51.1294V106.52M432.821 51.1294L421.254 36.9268M421.254 36.9268V0",
    stroke: "black"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 401.5,
    y: 123.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 140.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 140.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 157.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 174.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 191.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 208.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 225.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 242.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 259.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 276.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 293.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 310.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 327.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 344.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 361.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 378.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 412.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 429.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 446.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 446.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 429.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 412.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 378.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 361.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 344.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 327.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 310.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 293.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 276.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 259.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 242.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 225.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 208.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 191.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 174.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 157.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 412.5,
    y: 123.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 423.5,
    y: 123.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 434.5,
    y: 123.5,
    width: 6,
    height: 10,
    fill: "black",
    stroke: "black"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 157.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 157.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 174.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 208.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 208.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 225.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 242.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 259.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 276.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 293.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 310.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 327.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 344.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 361.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 378.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 412.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 429.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 441.5,
    y: 446.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 208.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 225.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 242.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 259.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 276.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 293.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 310.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 327.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 344.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 361.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 378.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 412.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 429.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 446.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 225.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 242.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 259.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 276.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 293.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 310.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 327.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 344.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 361.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 378.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 412.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 429.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 394.5,
    y: 446.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 446.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 208.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 225.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 242.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 259.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 276.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 293.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 310.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 327.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 344.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 361.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 378.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 395.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 412.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 381.5,
    y: 429.5,
    width: 6,
    height: 10,
    fill: "#010101",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M448 174.5V184.5H442V174.5H448Z",
    fill: "#010101",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125 471H22V464.987V126.268V118.752L48.9634 114.994V97.7074L53.2775 95.2021L61.3665 93.6989L68.9162 92.6968V68.6457L67.2984 67.1425V60.6287L69.4555 59.1255H74.5785H79.7016L81.3194 60.6287V67.1425L79.1623 68.6457V92.6968H83.4764L91.0262 93.6989L98.5759 95.2021L101.812 97.7074V115.201L125 118.752V464.987V471Z",
    fill: "#4DB7D8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9267 111.236L22 464.987M75.9267 111.236L125 464.987M75.9267 111.236L48.9634 114.994M75.9267 111.236L101.812 115.201M22 464.987V471H125V464.987M22 464.987V126.268V118.752L48.9634 114.994M125 464.987V118.752L101.812 115.201M48.9634 114.994V97.7074L53.2775 95.2021L61.3665 93.6989L68.9162 92.6968M68.9162 92.6968V68.6457M68.9162 92.6968H79.1623M101.812 115.201V97.7074L98.5759 95.2021L91.0262 93.6989L83.4764 92.6968H79.1623M68.9162 68.6457H79.1623M68.9162 68.6457L67.2984 67.1426V60.6287L69.4555 59.1255H74.5785M79.1623 68.6457V92.6968M79.1623 68.6457L81.3194 67.1426V60.6287L79.7016 59.1255H74.5785M74.5785 0V59.1255",
    stroke: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 110L126 470.5H22L76.5 110Z",
    fill: "#A0D9E6",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: 130.5,
    x2: 78,
    y2: 130.5,
    stroke: "#BBE1EC"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 142.5,
    x2: 80,
    y2: 142.5,
    stroke: "#BBE1EC"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 154.5,
    x2: 82,
    y2: 154.5,
    stroke: "#BBE1EC"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 166.5,
    x2: 82,
    y2: 166.5,
    stroke: "#BBE1EC"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 178.5,
    x2: 84,
    y2: 178.5,
    stroke: "#BBE1EC"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 190.5,
    x2: 86,
    y2: 190.5,
    stroke: "#BBE1EC"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 202.5,
    x2: 88,
    y2: 202.5,
    stroke: "#BBE1EC"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 214.5,
    x2: 90,
    y2: 214.5,
    stroke: "#BBE1EC"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 226.5,
    x2: 91,
    y2: 226.5,
    stroke: "#BBE1EC"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 238.5,
    x2: 93,
    y2: 238.5,
    stroke: "#BBE1EC"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 250.5,
    x2: 95,
    y2: 250.5,
    stroke: "#BBE1EC"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 262.5,
    x2: 96,
    y2: 262.5,
    stroke: "#BBE1EC"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 274.5,
    x2: 98,
    y2: 274.5,
    stroke: "#BBE1EC"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 286.5,
    x2: 99,
    y2: 286.5,
    stroke: "#BBE1EC"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 49,
    y1: 298.5,
    x2: 101,
    y2: 298.5,
    stroke: "#BBE1EC"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 310.5,
    x2: 103,
    y2: 310.5,
    stroke: "#BBE1EC"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 322.5,
    x2: 105,
    y2: 322.5,
    stroke: "#BBE1EC"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 334.5,
    x2: 106,
    y2: 334.5,
    stroke: "#BBE1EC"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 346.5,
    x2: 107,
    y2: 346.5,
    stroke: "#BBE1EC"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 358.5,
    x2: 110,
    y2: 358.5,
    stroke: "#BBE1EC"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 370.5,
    x2: 111,
    y2: 370.5,
    stroke: "#BBE1EC"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 382.5,
    x2: 113,
    y2: 382.5,
    stroke: "#BBE1EC"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 394.5,
    x2: 114,
    y2: 394.5,
    stroke: "#BBE1EC"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 406.5,
    x2: 116,
    y2: 406.5,
    stroke: "#BBE1EC"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 418.5,
    x2: 118,
    y2: 418.5,
    stroke: "#BBE1EC"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 430.5,
    x2: 119,
    y2: 430.5,
    stroke: "#BBE1EC"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 442.5,
    x2: 121,
    y2: 442.5,
    stroke: "#BBE1EC"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 454.5,
    x2: 123,
    y2: 454.5,
    stroke: "#BBE1EC"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 466.5,
    x2: 124,
    y2: 466.5,
    stroke: "#BBE1EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 342V471H302V342H298V331H376V342H371.5Z",
    fill: "#C63030"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M371.5 342V471H302V342M371.5 342H302M371.5 342H376V331H298V342H302",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M376 342V331H298V342H376Z",
    fill: "#9A9DA0",
    stroke: "black"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 421,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 444,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 444,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 444,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 444,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 421,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 421,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 421,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 398,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 398,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 398,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 398,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 375,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 375,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 375,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 375,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 352,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 351,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 351,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 351,
    width: 9,
    height: 14,
    fill: "#030000",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 270.5H126V277.5H221.5V270.5Z",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 277.5H126V284.5H221.5V277.5Z",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 284.5H126V291.5H221.5V284.5Z",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 263.5H126V270.5H221.5V263.5Z",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 259H126V275.5V471H221.5V259Z",
    fill: "#9D9EA0",
    stroke: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 410.5H126V417.5H221.5V410.5Z",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 347.5H126V354.5H221.5V347.5Z",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 284.5H126V291.5H221.5V284.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 291.5H126V298.5H221.5V291.5Z",
    stroke: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 298.5H126V305.5H221.5V298.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 305.5H126V312.5H221.5V305.5Z",
    stroke: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 312.5H126V319.5H221.5V312.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 319.5H126V326.5H221.5V319.5Z",
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 326.5H126V333.5H221.5V326.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 333.5H126V340.5H221.5V333.5Z",
    stroke: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 340.5H126V347.5H221.5V340.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 410.5H126V417.5H221.5V410.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 424.5H126V431.5H221.5V424.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 431.5H126V438.5H221.5V431.5Z",
    stroke: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 438.5H126V445.5H221.5V438.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 445.5H126V452.5H221.5V445.5Z",
    stroke: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 452.5H126V459.5H221.5V452.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 354.5H126V361.5H221.5V354.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 361.5H126V368.5H221.5V361.5Z",
    stroke: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 368.5H126V375.5H221.5V368.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 375.5H126V382.5H221.5V375.5Z",
    stroke: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 382.5H126V389.5H221.5V382.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 389.5H126V396.5H221.5V389.5Z",
    stroke: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 396.5H126V403.5H221.5V396.5Z",
    fill: "#535456",
    stroke: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 403.5H126V410.5H221.5V403.5Z",
    stroke: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5 403.5H126V410.5H221.5V403.5Z",
    stroke: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M520 163L466 211V470.5H526V163H520Z",
    fill: "#8BB3D1",
    stroke: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M526 225H466V231H526V225Z",
    stroke: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M466 225V220H526V225H466Z",
    fill: "#010101",
    stroke: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M526 231H466V237H526V231Z",
    fill: "#010101",
    stroke: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M526 249H466V255H526V249Z",
    stroke: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M526 255H466V261H526V255Z",
    fill: "#010101",
    stroke: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M526 261H466V267H526V261Z",
    stroke: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M526 267H466V273H526V267Z",
    fill: "#010101",
    stroke: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M526 279H466V285H526V279Z",
    stroke: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M526 285H466V291H526V285Z",
    stroke: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M526 291H466V297H526V291Z",
    fill: "#010101",
    stroke: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M466 273H526M466 273C489.431 273 502.569 273 526 273V279H466V273Z",
    stroke: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M526 279H466V285H526V279Z",
    fill: "#010101"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M466 279H526M466 279C489.431 279 502.569 279 526 279V285H466V279Z",
    stroke: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M526 297H466V303H526V297Z",
    stroke: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M526 303H466V309H526V303Z",
    fill: "#010101",
    stroke: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M526 309H466V315H526V309Z",
    stroke: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M526 315H466V321H526V315Z",
    fill: "#010101",
    stroke: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M526 321H466V327H526V321Z",
    stroke: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M526 327H466V333H526V327Z",
    fill: "#010101",
    stroke: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M526 333H466V339H526V333Z",
    stroke: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M526 339H466V345H526V339Z",
    fill: "#010101",
    stroke: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M526 345H466V351H526V345Z",
    stroke: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M526 237H466V243H526V237Z",
    stroke: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M526 243H466V249H526V243Z",
    fill: "#010101",
    stroke: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M526 351H466V357H526V351Z",
    fill: "#010101",
    stroke: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M526 357H466V363H526V357Z",
    stroke: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M526 375H466V381H526V375Z",
    fill: "#010101",
    stroke: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M526 363H466V369H526V363Z",
    fill: "#010101",
    stroke: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M526 387H466V393H526V387Z",
    fill: "#010101",
    stroke: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M526 393H466V399H526V393Z",
    stroke: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M526 399H466V405H526V399Z",
    fill: "#010101",
    stroke: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M526 405H466V411H526V405Z",
    stroke: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M526 411H466V417H526V411Z",
    fill: "#010101",
    stroke: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M526 417H466V423H526V417Z",
    stroke: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M526 423H466V429H526V423Z",
    fill: "#010101",
    stroke: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M526 429H466V435H526V429Z",
    stroke: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M526 435H466V441H526V435Z",
    stroke: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M526 435H466V441H526V435Z",
    fill: "#010101",
    stroke: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M526 441H466V447H526V441Z",
    stroke: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M526 447H466V453H526V447Z",
    fill: "#010101",
    stroke: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M526 453H466V459H526V453Z",
    stroke: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M526 459H466V465H526V459Z",
    fill: "#010101",
    stroke: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M302 402.5V471L295 470.956L281 470.867L275.5 470.832L250.5 470.674L245.5 470.642L223 470.5L223.5 401H226L225.5 381H228V361.5L237.5 301V292H240V301L248.676 361.5L248.5 381.5H251L250.5 401L262.5 382.5V375.5H260.5V374.5H262.5V372H264.5V374.5H266.5V375.5H264.5V382.5L275.5 400V381H278.5V361.5L287 301V292H289V301L298 363V381H300V402.5H302Z",
    fill: "#F9E0A6"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 470.642L223 470.5L223.5 401H226L225.5 381H228V361.5L237.5 301V292H240V301L248.676 361.5L248.5 381.5H251L250.5 401L262.5 382.5V375.5H260.5V374.5H262.5V372H264.5V374.5H266.5V375.5H264.5V382.5L275.5 400V381H278.5V361.5L287 301V292H289V301L298 363V381H300V402.5H302V471L295 470.956L281 470.867L275.5 470.832L250.5 470.674L245.5 470.642ZM245.5 470.642L231 470.5",
    stroke: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M255 452.5V470.5H272V452.5L263.5 442L255 452.5Z",
    fill: "#64492E",
    stroke: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M236.478 376.5H234C233.448 376.5 233 376.052 233 375.5V353.236C233 353.081 233.036 352.927 233.106 352.788L234.106 350.789C234.474 350.052 235.526 350.052 235.894 350.789L236.899 352.799C236.966 352.931 237.002 353.077 237.005 353.225L237.478 375.479C237.49 376.039 237.039 376.5 236.478 376.5Z",
    fill: "#694C26",
    stroke: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M242.978 376.5H240.5C239.948 376.5 239.5 376.052 239.5 375.5V353.236C239.5 353.081 239.536 352.927 239.606 352.788L240.606 350.789C240.974 350.052 242.026 350.052 242.394 350.789L243.399 352.799C243.466 352.931 243.502 353.077 243.505 353.225L243.978 375.479C243.99 376.039 243.539 376.5 242.978 376.5Z",
    fill: "#694C26",
    stroke: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M285.978 376.5H283.5C282.948 376.5 282.5 376.052 282.5 375.5V353.236C282.5 353.081 282.536 352.927 282.606 352.788L283.606 350.789C283.974 350.052 285.026 350.052 285.394 350.789L286.399 352.799C286.466 352.931 286.502 353.077 286.505 353.225L286.978 375.479C286.99 376.039 286.539 376.5 285.978 376.5Z",
    fill: "#694C26",
    stroke: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M292.978 376.5H290.5C289.948 376.5 289.5 376.052 289.5 375.5V353.236C289.5 353.081 289.536 352.927 289.606 352.788L290.606 350.789C290.974 350.052 292.026 350.052 292.394 350.789L293.399 352.799C293.466 352.931 293.502 353.077 293.505 353.225L293.978 375.479C293.99 376.039 293.539 376.5 292.978 376.5Z",
    fill: "#694C26",
    stroke: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M235 457.5V470.5H242V457.5L238.5 451L235 457.5Z",
    fill: "#64492E",
    stroke: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M284.5 457.5V470.5H291.5V457.5L288 451L284.5 457.5Z",
    fill: "#64492E",
    stroke: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M292 429H284L284.5 414.5L288 409.5L291.5 414.5L292 429Z",
    fill: "#64492E",
    stroke: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M241.5 428.5H233.5L234 414L237.5 409L241 414L241.5 428.5Z",
    fill: "#64492E",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 263.5,
    cy: 413,
    r: 8.5,
    fill: "#64492E",
    stroke: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M263.5 372V381.947V382.5",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.1848d37a57cd509e658e4f6f9c92fc57.svg";
export { ForwardRef as ReactComponent };